<template>
  <div class="welcome">
    <h1 style="text-align: center;"><b>Welcome To CalsoB</b></h1>
  </div>
  <div
    class="modal fade"
    id="ageCheck"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    data-backdrop="static"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-center" id="exampleModalLabel">
            Welcome to CalsoB
          </h5>

          <!-- <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button> -->
        </div>
        <div class="modal-body text-center">
          <h4><b>Are you 21 or older?</b></h4>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="button button-primary d-block w-100"
            data-dismiss="modal"
            @click="handleAge"
          >
            Yes
          </button>
          <button
            type="button"
            class="button button-primary d-block w-100"
            @click="handleNo"
          >
            No
          </button>
        </div>
        <div>
          <p class="p-3" v-if="!isLegalAge">
            Thank you for your honesty. Let's wait for you to be 21 years or
            above.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLegalAge: true,
    };
  },
  methods: {
    handleAge() {
      localStorage.setItem("age", true);
      window.location.href = "/";
      this.isLegalAge = true;
    },
    handleNo() {
      this.isLegalAge = false;
    },
  },
  mounted() {
    $(window).on("load", function () {
      $("#ageCheck").modal("show");
    });
  },
};
</script>

<style scoped>
.modal {
  z-index: 100;
}
.modal-body {
  height: 50%;
}
.welcome {
  display: flex;
  top: 50;
  height: 100vh;
  justify-content: center;
  align-items: center;
}

@media (max-width: 575px) {
  .modal-dialog {
    width: auto;
  }
}
</style>
